import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { HoardOrder } from "../state/types"

export const useHoardActions = () => {
    const saveActions = useSaveActions()

    const saveHoard = (hoard: HoardOrder) => {
        const { save } = saveActions()
        return save(TableName.HOARD_ORDERS, hoard) as Promise<HoardOrder>
    }

    const removeHoard = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.HOARD_ORDERS, id)
    }

    return {
        saveHoard,
        removeHoard
    }
}
